import { InjectionToken, Provider } from '@angular/core';
import { Configuration } from '@core/api/generated/accounts-public/v1';
import { TermsPublicApi } from '@core/api/generated/accounts-public/v1/api/termsPublic.service';
import { environment } from '@environments/environment';
import { createMockService } from '../mock.utils';
import { ACCOUNTS_PUBLIC_API_CONFIG } from './accounts-public.config';

export const HTTP_ACCOUNTS_PUBLIC_SERVICE = new InjectionToken<TermsPublicApi>('AccountsPublicApi');

export const accountsPublicApiFactory = (realService: TermsPublicApi) => {
    if (environment.useMocks) {
        return createMockService('accounts-public', realService);
    }
    return realService;
};

export const ACCOUNTS_PUBLIC_API_PROVIDER: Provider[] = [
    {
        provide: Configuration,
        useValue: ACCOUNTS_PUBLIC_API_CONFIG,
    },
    {
        provide: HTTP_ACCOUNTS_PUBLIC_SERVICE,
        useFactory: accountsPublicApiFactory,
        deps: [TermsPublicApi],
    },
];
